exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.payment-option {\n  width: 700px;\n  margin: auto;\n  padding: 30px;\n}\n.custom-box > div {\n  width: 25%;\n  margin-right: 0;\n  margin-bottom: 20px;\n}\n", ""]);

// exports
